import React from 'react';
import { Input } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router';
import Constants from '../../config/constants'
import Pagination from "react-js-pagination";
import toast from '../../components/toast'
import LoadingWheel from '../../components/loadingwheel'
import sensorService from '../../services/sensorService';
import soapSensorStore, { SoapSensorData } from '../../store/soapSensorStore';
import RawDataModal from '../../components/rawdatamodal';
import ExportModal from '../../components/exportsensordata'
import authStore from '../../store/authStore';
import Select from '../../components/select';
import {Organization} from '../../interface'
import organizationService from '../../services/organizationService';
import "./SensorData.css"
import Utils from '../../helpers/Utility';
import moment from 'moment'
import E2GraphModal from '../../components/e2GraphModal/GraphModal';

const { Search } = Input;
export interface SoapSensorProps extends RouteComponentProps {}
export interface SoapSensorState {
    soapSensorData      :   Array<SoapSensorData>
    isLoading       :   Boolean,
    sensorFilter    :   string;
    organizationList:   Array<Organization>;
    organizationFilter? : any;
    pageNumber      :   number;
    showModal       :   boolean;
    sensorBoxName   : string;
    selecetedSensorBox: any;
    showExportModal : boolean;
    modalData       :   string;
    showGraphModal  :   boolean;
    selectedActualName: string;
}

class soapSensorDataList extends React.Component<SoapSensorProps, SoapSensorState> {

    searchSensorRaw: any
    constructor(props : any){
        super(props);

        this.state = {
            soapSensorData  : [],
            sensorFilter    : '',
            organizationList: [],
            organizationFilter : {},
            isLoading       : true,
            pageNumber      : 1,
            showModal       : false,
            sensorBoxName   : 'E2Sensordata',
            selecetedSensorBox: {},
            showExportModal : false,
            modalData       : '',
            showGraphModal  : false,
            selectedActualName: '',
        }

    this.searchSensorRaw = Utils.debounce(this.getSensorData, 700);
    }

    async componentDidMount(){
        // note : temp solution for the org admin access to all org
        if(authStore?.isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)){
            await this.getOrganisations();
        }
        soapSensorStore.sensorData = [];
        await this.getSensorData(this.state.sensorFilter);
    }

    showModal = (data: string) =>{
        this.setState({modalData: data},()=>{
            Utils.showModal('rawData')
        })
    }

    showExportModal(exportData: any) {
        this.setState({ sensorBoxName: 'E2Sensordata', selecetedSensorBox: exportData, showExportModal :true})
    }

    closeExportModal = () => {
        this.setState({ sensorBoxName: '', selecetedSensorBox: '', showExportModal :false })
    }

    showGraphModal = () => {
        // Graph shows all E2 sensor data, no need for actual_name filter
        this.setState({ 
            showGraphModal: true, 
            selectedActualName: 'E2SensorData',
            selecetedSensorBox: { actual_name: 'E2SensorData' }
        });
    }

    closeGraphModal = () => {
        this.setState({ showGraphModal: false, selectedActualName: '' });
    }

    getSensorData = async(actualName: string) => {
        try { 
            this.setState({isLoading: true, sensorFilter: actualName })
            let SoapSensorData = await sensorService.getE2SensorData(actualName, this.state.organizationFilter._id)
            
            soapSensorStore.sensorData = SoapSensorData; // parsedInput.data.data; //data; // latestRawData.value;
            this.setState({
                soapSensorData: soapSensorStore.sensorData.slice( 0, Constants.maxLimit),
                isLoading : false,
                pageNumber: 1
            })
        }catch(error){
            this.setState({isLoading : false})
            console.error(error)
            toast.error(error.response.data.message)
        }
    }

    getOrganisations :any = async () => {
        try {
                const response = await organizationService.getOrganizations()
                this.setState({organizationList : response.data.organizations , organizationFilter : response.data.organizations[0]})
        } catch (error) {
                toast.error(error.response.data.message)
                this.setState({isLoading : false})
        }
    }

    // Helper function to get GUI representation for digit types
    getGUIRepresentation = (value: number, dataType: string, engUnits: string) => {
        if (dataType === "DataTypeDigital") {
            if (engUnits === "ON/OFF" || engUnits === "Yes/No")
                return value
            return (engUnits === "Yes/No") ? (value === 1 ? "Yes" : value === 0 ? "No" : "INVALID") : (value === 1 ? "ON" : value === 0 ? "OFF" : "INVALID");

            // if(engUnits === "Yes/No")
            //     return (engUnits === "Yes/No") ? (value === 1 ? "Yes" : value === 0 ? "No" : "INVALID") : (value === 1 ? "ON" : value === 0 ? "OFF" : "INVALID");
            // else
            //     return value === 1 ? "ON" : value === 0 ? "OFF" : "INVALID";
        }
        return value; // Return the value directly for non-digit types
    };

    handleFilterOrganization(option: any){
        this.setState({organizationFilter : option},()=>{
            this.getSensorData(this.state.sensorFilter);
        })
    }

    onPageChange = (pageNumber: number) => {
        const skip  = Constants.maxLimit * (pageNumber - 1);
        const limit = Constants.maxLimit * (pageNumber - 1) + Constants.maxLimit;
        this.setState({
            soapSensorData: soapSensorStore.sensorData.slice( skip, limit ),
            isLoading : false,
            pageNumber
        })
    }

    setSearchFilter(value: string) {

        this.setState({ sensorFilter: value }, () => {
            this.searchSensorRaw( value )
        })

    }

    cleanEscapedCharacters(jsonString: string): string {
        return jsonString
          .replace(/\\b/g, '')
          .replace(/\\f/g, '')
          .replace(/\\n/g, '')
          .replace(/\\r/g, '')
          .replace(/\\t/g, '')
          .replace(/\\"/g, '"')
          .replace(/\\\\/g, '\\');
    }

    render(){
        return (

            <div className="padding-b50">
              <div className="row mb-25 align-items-center">
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex align-items-center">
                        <p className="table-title media-padding mb-0">E2 Sensor Data
                        {this.state.soapSensorData?.length > 0 && (
                            <>
                                <i 
                                    className="fa fa-download cursor-pointer ml-3" 
                                    onClick={(e : any) => { e.stopPropagation(); this.showExportModal(this.state.soapSensorData); }} 
                                    aria-hidden="true"
                                    title="Export Data"
                                    style={{ fontSize: '18px', color: '#ffffff', display: 'inline-block', backgroundColor: '#4F8C92', borderRadius: '6px', padding: '9px'}}
                                ></i>
                                <i 
                                    className="fa fa-line-chart cursor-pointer ml-3" 
                                    onClick={(e: any) => { 
                                        e.stopPropagation(); 
                                        this.showGraphModal(); 
                                    }} 
                                    aria-hidden="true"
                                    title="View Graph"
                                    style={{ fontSize: '16px', color: '#ffffff', display: 'inline-block', backgroundColor: '#4F8C92', borderRadius: '6px', padding: '10px'}}
                                ></i>
                            </>
                        )}
                        </p>
                      
                  </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex align-items-end justify-content-end">
                        {// note : temp solution for the org admin access to all org
                        (authStore?.isSuperAdmin || (authStore?.isOrgAdmin() && authStore.currentUser.is_default)) &&
                                <div className="filter-select mr-3">
                                    <label className="custom-label">Organization</label>
                                        <Select name = "typeFilter"
                                                data = {this.state.organizationList}
                                                value = {this.state.organizationFilter}
                                                onChange = {(e:any)=>this.handleFilterOrganization(e)}
                                        />
                                </div>
                        }
                        <div className="filter-select media-margin-tp">
                            <Search
                                placeholder="Search"
                                value={this.state.sensorFilter}
                                size="large"
                                onChange={(e) => this.setSearchFilter(e.target.value)}
                                allowClear
                                enterButton />
                        </div>
                    </div>
               </div>
               {this.state.soapSensorData?.length !== 0 ?
                <div className="row no-gutters table-wrap">
                    <table className="table custom-table table-style">
                        <thead className="table-header-bg">
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">Actual name</th>
                            <th scope="col">value</th>
                            <th scope="col">engUnits</th>
                            <th scope="col">Alarm</th>
                            <th scope="col">Notice</th>
                            <th scope="col">Fail</th>
                            <th scope="col">Overriden</th>
                            <th scope="col">Last Update</th>
                            {/* <th scope="col">ackUser</th>
                            <th scope="col">Section</th>
                            <th scope="col">ackTimestamp</th>
                            <th scope="col">reportValue</th>
                            <th scope="col">limit</th>
                            <th scope="col">engUnits</th> 
                            <th scope="col">Original prop</th>
                            <th scope="col">prop</th>
                            <th scope="col">status</th>
                            <th scope="col">ovTime</th>
                            <th scope="col">ovType</th>
                            <th scope="col">dataType</th>  */}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.soapSensorData ?
                                this.state.soapSensorData.map((item : SoapSensorData,index) =>{
                                    return(
                                        <tr className='click-icon' key={index} onClick={()=>this.showModal(JSON.stringify(item))}>
                                        <th scope="row">{(Constants.maxLimit * (this.state.pageNumber - 1)) + index + 1}</th>
                                        <td>{item.actual_name}</td>
                                        <td>{this.getGUIRepresentation(item.value, item.dataType, item.engUnits)}</td>
                                        <td>{item.engUnits}</td>
                                        <td>{item.alarm.toString()}</td>
                                        <td>{item.notice.toString()}</td>
                                        <td>{item.fail.toString()}</td>
                                        <td>{item.overriden.toString()}</td>
                                        <td title = {item?.created_on || Date.now() ? moment(item?.created_on).format('MM/DD/YYYY, HH:mm:ss') : '-'}>
                                            {item?.created_on || Date.now() ? moment(item?.created_on).format('MM/DD/YYYY, HH:mm:ss') : '-'}
                                        </td>                                        
                                        {/* <td>{item.ackUser}</td>
                                        <td>{item.ackTimestamp}</td>
                                        <td>{item.reportValue}</td>
                                        <td>{item.limit}</td>
                                        <td>{item.engUnits}</td>
                                        <td>{item.section}</td>
                                        <td>{item.original_prop}</td>
                                        <td>{item.prop}</td>
                                        <td>{item.status}</td>
                                        <td>{item.ovTime}</td>
                                        <td>{item.ovType}</td>
                                        <td>{item.dataType}</td> */}
                                        </tr>
                                    )

                                })
                                : null 
                            }
                        </tbody>
                        </table>
                </div>  
                : <>
                    {
                    soapSensorStore.sensorData?.length === 0 && !this.state.isLoading && (
                        <div className="text-center w-100 no-card-ph">
                            <div className="no-result-container">
                                <p className="no-cards"> No data found!</p>
                            </div>
                        </div> 
                       )
                    }
                    </>
                }        
               <div className="pagination-container">
               {Math.ceil(soapSensorStore.sensorData.length/Constants.maxLimit ) > 1?
   
                        <Pagination
                            hideNavigation
                            activePage={this.state.pageNumber}
                            itemsCountPerPage={Constants.maxLimit}
                            totalItemsCount={soapSensorStore.sensorData.length}
                            itemClass={"item-class"}
                            activeClass={"active-class"}
                            pageRangeDisplayed={5}
                            onChange={this.onPageChange}
                            />
                    
                    : null
                }
                </div> 
             {this.state.isLoading ? 
                <LoadingWheel/>
                :  null}
            <RawDataModal rawData={this.state.modalData}/>
            <ExportModal
                    show={this.state.showExportModal}
                    closeModal={this.closeExportModal}
                    SensorBoxName={this.state.sensorBoxName}
                    GroupId=''
                    orgId = {this.state.organizationFilter?._id}
            />
            {this.state.showGraphModal && this.state.selectedActualName && (
                <E2GraphModal
                    SensorBoxName={this.state.selectedActualName}
                    closeGraphModal={this.closeGraphModal}
                    sensorBox={this.state.selecetedSensorBox}
                />
            )}
          </div> 
        )
    }
}

export default withRouter(soapSensorDataList)